import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { FaChevronRight } from "react-icons/fa";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";

// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";

import "./You_might_also_like.css";
import IllustrationCard from "../illustrationCard/IllustrationCard";

// Added data and breakpoints as props with default values as fallbacks
const You_might_also_like = ({ data = [], breakpoints = null }) => {
  
  // Default breakpoints fallback if none are provided via props
  const defaultBreakpoints = {
    576: {
      slidesPerView: 2,
    },
  };

  return (
    <div className="career-categories-grid-parent You_might_also_like">
      <Container className="py-4">
        <Row className="g-4">
          {/* LEFT SECTION: Highlight Category Block */}
          <Col lg={12} md={12}>
            <div className="category-block highlight-block">
              <div className="category-header mb-3">
                <div>
                  <h3 className="category-title">You might also like</h3>
                </div>
              </div>

              {/* Swiper Slider Wrapper */}
              <div className="inner-cards-relative-wrap">
                {/* Only render Swiper if there is data */}
                {data.length > 0 ? (
                  <Swiper
                    modules={[Navigation]}
                    spaceBetween={16}
                    slidesPerView={1}
                    navigation={{
                      nextEl: ".slider-arrow-btn", // Binds custom button to Swiper
                    }}
                    breakpoints={breakpoints || defaultBreakpoints}
                    className="mySwiper"
                  >
                    {data.map((item, index) => (
                      <SwiperSlide key={index}>
                        <div className="product-card">
                          <IllustrationCard
                            imageSrc={item.imageSrc}
                            title={item.title}
                            link={item.link}
                          />
                          <h4 className="product-title">{item.title}</h4>
                          <p className="product-desc">{item.description}</p>
                          <div className="product-pricing">
                            <span className="price-label">Starting @</span>
                            <span className="price-value">{item.price}</span>
                          </div>
                        </div>
                      </SwiperSlide>
                    ))}
                  </Swiper>
                ) : (
                  <p>No recommendations available.</p>
                )}

                {/* Circular Slider Floating Arrow Navigation */}
                <button className="slider-arrow-btn" aria-label="Next slide">
                  <FaChevronRight />
                </button>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default You_might_also_like;